export default "__VITE_ASSET__ee9b19e8__"